import { useAppSelector } from "../../stateManagement/hooks/redux";
import ContentHeader from "../../widgets/contentHeader/ContentHeader";
import TransportHistoryObjectDrivewaysTable from "../../widgets/transport/transportHistoryObjectDrivewaysTable/TransportHistoryObjectDrivewaysTable";
import TransportObjectInfoSection from "../../widgets/transport/transportObjectInfoSection/TransportObjectInfoSection";

export default function TransportHistoryObjectPage() {

    const stateNumber = useAppSelector(state => state.transportObjectInfo.transportObjectInfoStateNumber)

    return (
        <>
            <ContentHeader title={stateNumber && `История движений транспортного средства «${stateNumber}»`} />
            <TransportObjectInfoSection type="history" />
            <TransportHistoryObjectDrivewaysTable />
        </>
    )
}
